import { observable } from 'mobx';
import { useEffect } from 'react';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { useLayerData } from '@src/utils/hooks/use-layer-data';
import { jumpPage } from '@src/utils/common-util';

import getPageLocalesData from '@src/global-locales/get-page-locales-data';
const pageLocalesData = getPageLocalesData();

class mechaPageStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  // 是否激活
  @observable isActive = false;
  // 形态切换
  @observable formChange = 1;
  // 动画
  @observable Animating = true;
  // page4数据
  @observable page4Data;

  @observable versionList = [];
  versionSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      spaceBetween: 0,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 500,
      on: {
        slideChange() {
          // alert('改变了，activeIndex为' + this.activeIndex);
        }
      }
    }
  });

  versionTabSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: -10
      // loopedSlides: 3
    }
  });
  // 处理选项卡点击事件
  handformChange = tabIndex => {
    this.formChange = tabIndex;
    this.Animating = true;
    const timer = setTimeout(() => {
      this.Animating = false;
    }, 600); // 动画持续时间 300ms
    return () => clearTimeout(timer);
  };
  toList() {
    if (!IS_DEV_ENV) {
      const url = 'mecha-list.html';
      jumpPage(url, '#/');
    } else {
      this.mainStore?.redirect('/mecha-list');
    }
  }
  // 跳转详情
  toDetails = mecha_id => {
    // IS_DEV_ENV  DEPLOY_ENV
    // Toast.info(`${pageLocalesData.global.comming_soon}`);
    // return;
    if (!IS_DEV_ENV) {
      const url = 'mecha.html';
      jumpPage(url, `#/?mecha_id=${mecha_id}`);
    } else {
      this.mainStore?.redirect(`/mecha?mecha_id=${mecha_id}`);
    }
  };
  handleTextOverflow = (element, formType) => {
    if (!element) return;

    const scrollWrapper = element.querySelector('.scroll-wrapper');
    const textCopies = scrollWrapper.querySelectorAll('.text-copy');

    // 等待DOM渲染完成后获取准确尺寸
    requestAnimationFrame(() => {
      const containerWidth = element.clientWidth;
      const textWidth = textCopies[0].getBoundingClientRect().width;

      // 设置CSS变量用于动画计算
      // scrollWrapper.style.setProperty('--text-width', `${textWidth - 10}px`);
      // scrollWrapper.style.setProperty('--container-width', `${containerWidth}px`);
      // console.log(1111);
      // 如果总宽度超过容器宽度，添加滚动类
      if (textWidth > containerWidth) {
        // 确保有两个文本副本用于无缝循环
        if (textCopies.length < 2) {
          const originalText = textCopies[0];
          const clone = originalText.cloneNode(true);
          scrollWrapper.appendChild(clone);
          // scrollWrapper.appendChild(clone);
        }
        // 添加必要的样式类
        scrollWrapper.classList.add('looping-animation');
      }
    });
  };

  use() {
    const Part4Date = useLayerData('mechaPageData');
    //console.log('Part4Date', Part4Date);

    useEffect(
      () => {
        if (!Part4Date) {
          return;
        }
        this.page4Data = Part4Date;
        // this.versionList = Part4Date?.mechaList;
      },
      [Part4Date]
    );

    useEffect(
      () => {
        if (this.isActive) {
          this.Animating = true;
          const timer = setTimeout(() => {
            this.Animating = false;
          }, 600); // 动画持续时间 300ms

          return () => clearTimeout(timer);
        }
      },
      [this.isActive]
    );
    useEffect(
      () => {
        this.versionSwiper.activeIndex = this.versionTabSwiper.activeIndex;
        this.Animating = true;
        const timer = setTimeout(() => {
          this.Animating = false;
        }, 600); // 动画持续时间 300ms

        return () => clearTimeout(timer);
      },
      [this.versionTabSwiper.activeIndex]
    );
    useEffect(
      () => {
        this.versionTabSwiper.activeIndex = this.versionSwiper.activeIndex;
        this.formChange = 1;
      },
      [this.versionSwiper.activeIndex]
    );
  }
}

export default mechaPageStore;
